import template from './calendarInlineHeader.html';
import controller from './calendarInlineHeader.controller';
import './calendarInlineHeader.scss';

let calendarInlineHeaderComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    id: '<'
  },
  template,
  controller
};

export default calendarInlineHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHeader/calendarInlineHeader.component.js